import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit {

  @Input()
  type?: 'DIALOG' | 'TOASTR' = 'DIALOG';

  @Input()
  content: string = '';

  @Input()
  title: string = 'การแจ้งเตือน';

  @Input()
  isInnerHTML: boolean = false;

  @Output()
  confirmEmit: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  close() {
    this.activeModal.close();
  }

  emit() {
    this.confirmEmit.emit(true);
  }
}
